import React from "react";

interface IProps {
    value: unknown;
}

export const DefaultCellRenderer = ({value}: IProps) => {
    const isValueTruthy = value !== null && value !== undefined;

    return <>{isValueTruthy ? value : "-"}</>;
};
import React from "react";

interface IProps {
    value: unknown;
}

export const DefaultCellRenderer = ({value}: IProps) => {
    const isValueTruthy = value !== null && value !== undefined;

    return <>{isValueTruthy ? value : "-"}</>;
};
